egtoVerificationField.$inject = [];

export function egtoVerificationField() {
    return {
        require: '^form',
        bindToController: {
            label: '@',
            code: '=',
            name: '@'
        },
        restrict: 'E',
        scope: {},
        controller: EgtoVerificationField,
        controllerAs: 'vm',
        templateUrl: 'app/components/verification-field.directive.html',
        link: link
    };

    function link(scope, element, attributes, form) {
        var validationCode;
        scope.vm.field = form[scope.vm.name];

        if (scope.vm.organization) {
            validationCode = "RJ202"; // Get validation code
            scope.vm.field.$validators.egtoCodeValidator = egtoCodeValidator; // Call to validate the code
        }

        ///////////////////
        // Do actual validation
        function egtoCodeValidator(modelValue, viewValue) {
            if (!viewValue || validationCode.length === 0) {
                return false;
            }
            return validationCode == scope.vm.code;
        }
    }
}
class EgtoVerificationField {
    constructor() {
    }
}
EgtoVerificationField.$inject = [];
